import { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchMerchandisingApi } from "app/pages/Merchandising/merchandisingActionCreators";
import PropTypes from "prop-types";
import AppGlobalsContext from "app/AppGlobalsContext";
import { computedProductDates } from "app/utils/utils";
import ProductListBlock from "app/pages/.shared/DynamicBlocks/blocks/ProductListBlock/ProductListBlock";
import { fetchProductsApi } from "app/pages/Listing/productActionCreators";
import { useIntl } from "react-intl";

const MAX_PRODUCTS = 3;

const ProductListBlockContainer = props => {
	const { merchCode, shortVersion, displayCatalogProductsOnly } = props;
	const [products, setProducts] = useState([]);
	const intl = useIntl();
	const [title, setTitle] = useState(
		intl.formatMessage({ id: "products.carousel.listing.title" })
	);
	const { shop, partnerCode, productsVisibility } = useContext(AppGlobalsContext);

	useEffect(() => {
		if (merchCode) {
			fetchMerchandisingApi({ code: merchCode, shop, productsVisibility, partnerCode }).then(
				response => {
					setTitle(response?.data?.merchandising?.label);

					let merchProductList = computedProductDates(response?.data?.products);
					let merchCatalogProductList = response?.data?.catalogProducts || [];
					merchCatalogProductList = computedProductDates(merchCatalogProductList);
					let finalProductList = merchProductList.concat(merchCatalogProductList);

					if (displayCatalogProductsOnly) {
						finalProductList = finalProductList.filter(product => !product.isFlashsale);
					} else {
						finalProductList = finalProductList.filter(product => product.isFlashsale);
					}

					if (shortVersion) {
						finalProductList = finalProductList.slice(0, MAX_PRODUCTS);
					}

					setProducts(finalProductList);
				}
			);
		} else {
			fetchProductsApi({ shop, productsVisibility, partnerCode }).then(response => {
				let newProductList = computedProductDates(response?.data?.products);

				if (shortVersion) {
					newProductList = newProductList.slice(0, MAX_PRODUCTS);
				}

				setProducts(newProductList);
			});
		}
	}, [
		merchCode,
		shop,
		productsVisibility,
		partnerCode,
		shortVersion,
		displayCatalogProductsOnly,
	]);

	return <ProductListBlock {...props} products={products} title={title} />;
};

ProductListBlockContainer.propTypes = {
	merchCode: PropTypes.string,
	shortVersion: PropTypes.bool,
	displayCatalogProductsOnly: PropTypes.bool,
};

const mapStateToProps = state => {
	return { showSmartDPOnRootUrl: state.partner.showSmartDPOnRootUrl };
};

export default connect(mapStateToProps)(ProductListBlockContainer);
